import {platform} from '../../utils/platform';
import {ms, msi} from '../normalizeSize';

const BASE = 16;

/**
 * Cross-platform function for converting a pixel value to rem.
 * @param {number} px - The pixel value to convert.
 * @returns {string} The rem value.
 */
export const getRem = (px: number): string => {
  if (platform.isWeb) {
    return `${px / BASE}rem`;
  }

  return ms(px);
};

/**
 * Cross-platform function for converting a pixel value to rem.
 * The same as `rem`, but returns a number
 * @param {number} px - The pixel value to convert.
 * @returns {number} The rem value.
 */
export const getRemi = (px: number): number => {
  if (platform.isWeb) {
    return px / BASE;
  }

  return msi(px);
};
